import { render, staticRenderFns } from "./NoPages.vue?vue&type=template&id=56f4e738&scoped=true&"
import script from "./NoPages.vue?vue&type=script&lang=js&"
export * from "./NoPages.vue?vue&type=script&lang=js&"
import style0 from "./NoPages.vue?vue&type=style&index=0&id=56f4e738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f4e738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
